
<template>
  <v-list-group :prepend-icon="prependIcon" v-if="games.length > 0">
    <template v-slot:activator>
      <v-list-item-title>{{title}}</v-list-item-title>
    </template>
    <template v-slot:prependIcon>
      <v-badge
        color="accent"
        :overlap="true"
        :value="overallBadgeCount > 0"
        :content="'' + overallBadgeCount"
      >
        <v-icon>{{prependIcon}}</v-icon>
      </v-badge>
    </template>
    <v-list-item v-for="game in games" :key="game.uid" link :to="'/game/' + game.uid">
      <template v-slot:default>
        <v-list-item-action>
          <v-badge
            color="accent"
            :overlap="true"
            :value="game.yourUnreadChatMessages ? game.yourUnreadChatMessages > 0 : false"
            :content="game.yourUnreadChatMessages"
          >
            <multi-icon
              right
              :icon="getGameTypeIcon(game.type)"
              :rightBottomIcon="getPlatformIcon(game.platform)"
              :rightBottomIconColor="'var(--v-secondary-base)'"
            />
          </v-badge>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{game.name}}</v-list-item-title>
        </v-list-item-content>
      </template>
    </v-list-item>
  </v-list-group>
</template>

<script>
import gameTypeMixin from "@/mixins/gameTypeMixin";
import platformMixin from "@/mixins/platformMixins";

export default {
  name: "GamesListGroup",
  mixins: [gameTypeMixin, platformMixin],
  props: {
    title: {
      type: String,
      required: true,
    },
    games: {
      type: Array,
      required: true,
    },
    prependIcon: {
      type: String,
      default: "mdi-creation",
    },
  },
  computed: {
    overallBadgeCount() {
      var ret = 0;
      this.games.forEach((game) => {
        ret += game.yourUnreadChatMessages ? game.yourUnreadChatMessages : 0;
      });
      return ret;
    },
  },
};
</script>